import React, { useState } from "react";
import { Table, InputNumber } from "antd";
import { ExamCourseScoreItem } from "service/service";
import style from "./style.module.scss";
import { ColumnProps } from "antd/lib/table/interface";

interface IScoreTableProps {
    list: ExamCourseScoreItem[];
    loading: boolean;
    onChange: (score: number, studentId: string) => void;
}

const ScoreTable: React.FC<IScoreTableProps> = ({
    list,
    loading,
    onChange
}) => {
    const SignRender = (signRecordCount: number, record: ExamCourseScoreItem) =>
        `${signRecordCount} / ${record.needSignRecourdCount}`;
    const DailyScoreRender = (
        dailyScore: string | null,
        record: ExamCourseScoreItem
    ) => (
        <EditRow
            onChange={score => onChange(score, record.studentId)}
            score={parseFloat(dailyScore || "0")}
        />
    );

    const columns: ColumnProps<ExamCourseScoreItem>[] = [
        {
            title: "序号",
            dataIndex: "index",
            key: "index",
            render: (text, column, index) => index + 1
        },
        { title: "学号", dataIndex: "studentNo" },
        { title: "姓名", dataIndex: "studentName" },
        { title: "签到", dataIndex: "signRecordCount", render: SignRender },
        { title: "作业成绩", dataIndex: "homeWork" },
        {
            title: "平时成绩",
            dataIndex: "dailyScore",
            render: DailyScoreRender
        },
        { title: "考试成绩", dataIndex: "examScore" },
        { title: "总成绩", dataIndex: "resultScore" }
    ];

    return (
        <Table
            loading={loading}
            dataSource={list}
            columns={columns}
            pagination={false}
            rowKey="studentNo"
            className={style.tableBorder}
        />
    );
};

interface EditRowProps {
    score: number;
    onChange: (score: number) => void;
}

const EditRow: React.FC<EditRowProps> = ({ score, onChange }) => {
    const [edit, setEdit] = useState(false);
    const [value, setValue] = useState(score);

    function onClick() {
        setEdit(true);
    }

    function onSave() {
        onChange(value);
        setEdit(false);
    }

    return edit ? (
        <InputNumber
            min={0}
            onChange={e => setValue(e || 0)}
            defaultValue={value}
            style={{ width: 100 }}
            ref={ref => ref && ref.focus()}
            onPressEnter={onSave}
            onBlur={onSave}
        />
    ) : (
        <div onClick={onClick} className={style.editRow}>
            {value}
        </div>
    );
};

export default ScoreTable;
